import "./index.scss";
import { language } from "../../locales";

const Footer = () => {
  return <div className="footer">{language?.config.component.footer.copyright}</div>
}
export default Footer;